define('media_cell_view.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('media_cell_view', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"media-cell\"><div data-type=\"backbone.collection.view.cell\"></div></div>";
},"useData":true}, 'extensions/C3/ShoppingExtensionsLatest/1.0.0/', 'extensions/C3/ShoppingExtensionsLatest/1.0.0/', Handlebars);
});